/**
 * Id minting for the client.
 *
 * `@beerwright/commands` deliberately mints no ids — the reducer is a pure
 * function of `(state, log)`, so every id has to arrive in a payload (see that
 * package's README). This is the one place the web app supplies them.
 *
 * Ids must satisfy `DOCUMENT_ID_PATTERN`: 1–64 characters of
 * `[A-Za-z0-9._:-]`, starting alphanumeric. A prefixed uuid does, and the
 * prefix makes a raw IndexedDB dump readable.
 */

/** Uuid v4, falling back to `Math.random` where `crypto.randomUUID` is absent. */
function uuid(): string {
  const cryptoRef = globalThis.crypto as Crypto | undefined;
  if (cryptoRef?.randomUUID) return cryptoRef.randomUUID();
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
}

/**
 * A new document id, e.g. `r-6f8d…` for a recipe.
 *
 * @param prefix - Short kind marker: `r` recipe, `f` fermentable, `h` hop,
 *   `y` yeast, `m` misc, `ms` mash step, `fs` fermentation step, `c` command.
 */
export function newId(prefix: string): string {
  return `${prefix}-${uuid()}`;
}
